'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFolder, iconFolderTag } from '@ni/nimble-components/dist/esm/icons/folder';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFolder };
export { iconFolderTag };
export const NimbleIconFolder = wrap(IconFolder);